"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addChangeSubcontract = addChangeSubcontract;
exports.afterSales = afterSales;
exports.associationKuJiaLe = associationKuJiaLe;
exports.batchCreateMes = batchCreateMes;
exports.batchCreateMesByContractId = batchCreateMesByContractId;
exports.batchCreateOrders = batchCreateOrders;
exports.batchPaySales = batchPaySales;
exports.batchUpdateTryInstall = batchUpdateTryInstall;
exports.countCustByOrderStatus = countCustByOrderStatus;
exports.createMes = createMes;
exports.default = void 0;
exports.delDesignScheme = delDesignScheme;
exports.getBomList = getBomList;
exports.getCmsCustDesignSchemeAuditList = getCmsCustDesignSchemeAuditList;
exports.getDesignSchemeUrl = getDesignSchemeUrl;
exports.getDesignSchemes = getDesignSchemes;
exports.getOrderAttAttachment = getOrderAttAttachment;
exports.getOriginalOrder = getOriginalOrder;
exports.orderReplenishmentCreate = orderReplenishmentCreate;
exports.orderRollback = orderRollback;
exports.paySales = paySales;
exports.queryByContractId = queryByContractId;
exports.queryCustOrderList = queryCustOrderList;
exports.removeBindKuJiaLeCustomerDesginId = removeBindKuJiaLeCustomerDesginId;
exports.saveDesid = saveDesid;
exports.saveKuJiaLeAuditList = saveKuJiaLeAuditList;
exports.statProductionStatusTotal = statProductionStatusTotal;
exports.syncApply = syncApply;
exports.updateOriginalOrder = updateOriginalOrder;

var _request = _interopRequireDefault(require("@/utils/request"));

// 查询设计方案（全部）
function getDesignSchemes(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/all',
    method: 'get',
    params: params
  });
} // 批量创建订单


function batchCreateOrders(data) {
  return (0, _request.default)({
    url: 'api/batchCreateOrders',
    method: 'post',
    data: data
  });
} // 保存设计方案ID


function saveDesid(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/saveDesid',
    method: 'post',
    data: data
  });
} // 关联酷家乐方案


function associationKuJiaLe(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/associationKuJiaLe',
    method: 'get',
    params: params
  });
} // 获取设计方案的设计地址


function getDesignSchemeUrl(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/getDesignSchemeUrl',
    method: 'get',
    params: params
  });
} // 设计方案同步数据


function saveKuJiaLeAuditList(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/saveKuJiaLeAuditList',
    method: 'post',
    data: data
  });
} // 查询提审单信息


function getCmsCustDesignSchemeAuditList(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/all',
    method: 'get',
    params: params
  });
} // 创建订单


function createMes(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/createMes',
    method: 'post',
    data: data
  });
} // 批量创建订单（通过合同id）


function batchCreateMesByContractId(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/batchCreateMesByContractId',
    method: 'post',
    data: data
  });
} // 批量创建订单


function batchCreateMes(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/batchCreateMes',
    method: 'post',
    data: data
  });
} // 批量更新试装状态


function batchUpdateTryInstall(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/batchUpdateTryInstall',
    method: 'put',
    data: data
  });
} // 查询订单列表根据不同的订单状态统计的客户数量


function countCustByOrderStatus(params) {
  return (0, _request.default)({
    url: 'api/cust/countCustByOrderStatus',
    method: 'get',
    params: params
  });
} // 查询订单列表


function queryCustOrderList(params) {
  return (0, _request.default)({
    url: 'api/cust/queryCustOrderList',
    method: 'get',
    params: params
  });
} // 批量付款(合同号)


function batchPaySales(data) {
  console.log('批量付款接口参数:', data);
  return (0, _request.default)({
    url: 'api/contractSpecialApply/batchPaySales',
    method: 'post',
    data: data
  });
} // 订单付款


function paySales(data) {
  console.log('订单付款接口参数:', data);
  return (0, _request.default)({
    url: 'api/contractSpecialApply/paySales',
    method: 'post',
    data: data
  });
} // 订单关联特殊申请


function syncApply(data) {
  console.log('订单关联特殊申请接口参数:', data);
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/syncApply',
    method: 'post',
    data: data
  });
} // 订单取消（售后申请）


function afterSales(data) {
  console.log('订单取消接口参数:', data);
  return (0, _request.default)({
    url: 'api/contractSpecialApply/afterSales',
    method: 'post',
    data: data
  });
} // 订单回退


function orderRollback(data) {
  console.log('订单回退接口参数:', data);
  return (0, _request.default)({
    url: 'api/contractSpecialApply/orderRollback',
    method: 'post',
    data: data
  });
} // 改单


function addChangeSubcontract(data) {
  console.log('改单接口参数:', data);
  return (0, _request.default)({
    url: 'api/contract/addChangeSubcontract',
    method: 'post',
    data: data
  });
} // 获取BOM数据


function getBomList(productionOrder) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/getBomList?productionOrder=' + productionOrder,
    method: 'get'
  });
} // 根据合同号查询物料（原单物料/其他物料）


function queryByContractId(params) {
  return (0, _request.default)({
    url: 'api/cmsCustBom/queryByContractId',
    method: 'get',
    params: params
  });
} // 创建补单


function orderReplenishmentCreate(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/addReplenishmentCreate',
    method: 'post',
    data: data
  });
} // 查询销售单附件


function getOrderAttAttachment(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/getOrderAttAttachment',
    method: 'get',
    params: params
  });
} // 获取原单号列表


function getOriginalOrder(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/getOriginalOrder',
    method: 'get',
    params: params
  });
} // 更新原单号


function updateOriginalOrder(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/updateOriginalOrder',
    method: 'put',
    data: data
  });
} // 删除设计方案


function delDesignScheme(ids) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme',
    method: 'delete',
    data: ids
  });
} // 统计生产订单状态数量


function statProductionStatusTotal(params) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/statProductionStatusTotal',
    method: 'get',
    params: params
  });
} // 取消关联酷家乐设计方案


function removeBindKuJiaLeCustomerDesginId(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/removeBindKuJiaLeCustomerDesginId',
    method: 'post',
    data: data
  });
}

var _default = {
  getDesignSchemes: getDesignSchemes,
  batchCreateOrders: batchCreateOrders,
  saveDesid: saveDesid,
  associationKuJiaLe: associationKuJiaLe,
  getDesignSchemeUrl: getDesignSchemeUrl,
  saveKuJiaLeAuditList: saveKuJiaLeAuditList,
  getCmsCustDesignSchemeAuditList: getCmsCustDesignSchemeAuditList,
  createMes: createMes,
  batchCreateMesByContractId: batchCreateMesByContractId,
  batchCreateMes: batchCreateMes,
  batchUpdateTryInstall: batchUpdateTryInstall,
  countCustByOrderStatus: countCustByOrderStatus,
  queryCustOrderList: queryCustOrderList,
  batchPaySales: batchPaySales,
  paySales: paySales,
  syncApply: syncApply,
  afterSales: afterSales,
  orderRollback: orderRollback,
  addChangeSubcontract: addChangeSubcontract,
  getBomList: getBomList,
  orderReplenishmentCreate: orderReplenishmentCreate,
  getOrderAttAttachment: getOrderAttAttachment,
  getOriginalOrder: getOriginalOrder,
  updateOriginalOrder: updateOriginalOrder,
  delDesignScheme: delDesignScheme,
  removeBindKuJiaLeCustomerDesginId: removeBindKuJiaLeCustomerDesginId,
  queryByContractId: queryByContractId,
  statProductionStatusTotal: statProductionStatusTotal
};
exports.default = _default;